import { DIMixins, DIValidators, EFeatureFlags } from "@/core/@types/types";
import { IF360FeatureFlagValidator } from "@/core/validators/F360FeatureFlagValidator";
import { IUsuarioAdminValidator } from "@/core/validators/usuarioAdmin/IUsuarioAdminValidator";
import { IAntecipaPermissionValidator } from "./IAntecipaPermissionValidator";
import { diContainer } from "@/core/di";
import type { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { inject, injectable } from "inversify";

@injectable()
export default class AntecipaPermissionValidator
  implements IAntecipaPermissionValidator
{
  @inject(DIMixins.USER_PROFILE_STORAGE)
  userProfileMixin!: IUserProfileStorageMixin;

  podeAcessar(): boolean | null {
    const featureAntecipa = diContainer
      .get<IF360FeatureFlagValidator>(DIValidators.FEATURE_FLAGS)
      .handleValidationByName(EFeatureFlags.telaAntecipa);
    const isAdm = diContainer
      .get<IUsuarioAdminValidator>(DIValidators.USUARIO_ADMIN)
      .handle();

    if (featureAntecipa && isAdm) return true;

    return false;
  }

  podeAntecipar(): boolean | null {
    // Se pode acessar, já significa que é admin (verificado em podeAcessar())
    return this.podeAcessar();
  }
}
